import {Injectable} from '@angular/core';
import {StepsService} from "./steps.service";
import {Choice} from "../models/choice.enum";
import {Device} from "../models/device.model";
import {Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ChoiceService {

    choice: string;
    selectedDevice: Device;

    choice$ = new Subject<string>();
    selectedDevice$ = new Subject<Device>();

    constructor(private stepSrv: StepsService) {
    }


    setDevice(device: Device) {
        this.selectedDevice = device
        this.selectedDevice$.next(device)
    }

    setChoice(choice: string) {
        this.choice = choice
        this.choice$.next(choice);
    }

    jumpTpStep3() {
        this.choice = Choice.none;
        this.stepSrv.setStep(3);
    }


}
